<div class="bf-start">
  <!--
    The one inverted surface on the page, and the only thing above the fold.
    A place is its four-letter code here, so the field that takes a code is
    the hero and everything else waits below it.
  -->
  <section class="evo-hero bf-start-hero">
    <p class="eyebrow">Airport briefings</p>

    <h1 class="bf-start-title">Which airport?</h1>

    <p class="bf-start-sub">
      Search by ICAO, IATA, name or city. Everything you open stays as a tab,
      so you can keep two fields side by side.
    </p>

    <!--
      Said once, up front, rather than discovered on the fifth section of the
      first briefing. Never "Sign in" -- this viewer is -- and never "Request
      an account" -- they have one.
    -->
    @if (!canReadDetail()) {
      <p class="bf-start-note" data-testid="start-access-note">
        Your account opens Overview and Runways. Noise, handling, entry, fees
        and charts need briefing access —
        <button type="button" class="bf-start-note-link" (click)="openAccessDialog()">
          what that covers
        </button>.
      </p>
    }

    <app-v2-airport-search
      class="bf-start-search"
      placeholder="LFPB, LBG, Le Bourget or Paris"
      [autofocus]="true"
      (airportSelected)="open($event)" />

    <div class="bf-quick">
      <span class="bf-quick-label">Jump to</span>

      @for (code of jumpCodes; track code) {
        <button
          type="button"
          class="bf-quick-code data"
          data-testid="jump-code"
          [disabled]="resolving() !== null"
          [attr.aria-busy]="resolving() === code"
          (click)="jump(code)">
          {{ code }}
        </button>
      }
    </div>

    @if (jumpError()) {
      <p class="bf-quick-error" data-testid="jump-error" role="status">{{ jumpError() }}</p>
    }
  </section>

  <!--
    Recents, not "popular airports": the second is a claim we would have to
    invent, and the first is the only list this page can honestly offer a
    signed-in planner. Cards lead with the code, because that is what the
    reader is scanning for -- no derived constraint flags, since every one of
    them in the mockup came out of free text (data-gaps G3).
  -->
  @if (recents().length) {
    <section class="bf-start-sec">
      <div class="bf-start-sec-head">
        <h2>Recent airports</h2>
        <span class="bf-start-sec-aside">This session</span>
      </div>

      <div class="bf-ap-grid">
        @for (airport of recents(); track airport.id) {
          <button
            type="button"
            class="bf-ap-card"
            data-testid="recent-airport"
            (click)="open(airport)">
            <span class="bf-ap-top">
              <span class="bf-ap-code data">{{ airport.icao }}</span>
              @if (airport.iata) {
                <span class="bf-ap-iata data">{{ airport.iata }}</span>
              }
            </span>
            <span class="bf-ap-place">{{ airport.name }}</span>
            @if (airport.city) {
              <span class="bf-ap-city">{{ airport.city }}</span>
            }
          </button>
        }
      </div>
    </section>
  }
</div>
